import React, { useEffect, useState } from 'react';
import { ErrorMessage, Formik, Form, Field } from 'formik';
import { MdOutlineFileCopy } from 'react-icons/md';
import { GiConfirmed } from 'react-icons/gi';
import {
  Button,
  Modal,
  ModalBody,
  Label,
  FormGroup,
  FormText
} from 'reactstrap';
import * as Yup from 'yup';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { toast } from 'react-toastify';
import { auth } from '../firebase';
import { onAuthStateChanged, signOut } from 'firebase/auth';

const schema = Yup.object().shape({
  u: Yup.string().required('Please enter username'),
  a: Yup.string().required('Please enter amount'),
  up: Yup.string().required('Please enter UTI ID')
});

const UTIForm = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const { origin } = window.location;
  const [url, setUrl] = useState('');
  const [urlLatest, setUrlLatest] = useState('');
  const [url1, setUrl1] = useState('');
  const [url2, setUrl2] = useState('');
  const [urlOld, setUrlOld] = useState('');
  const [copied, setCopied] = useState(false);
  const [copied2, setCopied2] = useState(false);
  const [copiedOld, setCopiedOld] = useState(false);
  const [copiedUrl1, setCopiedUrl1] = useState(false);
  const [copiedUrlLatest, setCopiedUrlLatest] = useState(false);

  const addLinkData = (str) => {
    setUrl(origin + '/app2/' + btoa(str));
    setUrlOld(origin + '/form1/' + btoa(str));
    setUrl1(origin + '/app3/' + btoa(str));
    setUrlLatest(origin + '/latest/' + btoa(str));
    setUrl2(origin + '/payment/' + btoa(str));
  };

  const handleCopy = () => {
    if (!url) return;
    navigator.clipboard.writeText(url);
    toast.info('Copied Successfully');
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 3000);
  };

  const handleCopyOld = () => {
    if (!urlOld) return;
    navigator.clipboard.writeText(urlOld);
    toast.info('Copied Successfully');
    setCopiedOld(true);
    setTimeout(() => {
      setCopiedOld(false);
    }, 3000);
  };

  const handleCopyLatest = () => {
    if (!urlLatest) return;
    navigator.clipboard.writeText(urlLatest);
    toast.info('Copied Successfully');
    setCopiedUrlLatest(true);
    setTimeout(() => {
      setCopiedUrlLatest(false);
    }, 3000);
  };

  const handleCopyUrl1 = () => {
    if (!urlOld) return;
    navigator.clipboard.writeText(url1);
    toast.info('Copied Successfully');
    setCopiedUrl1(true);
    setTimeout(() => {
      setCopiedUrl1(false);
    }, 3000);
  };

  const handleCopyUrl2 = () => {
    if (!url2) return;
    navigator.clipboard.writeText(url2);
    toast.info('Copied Successfully');
    setCopied2(true);
    setTimeout(() => {
      setCopied2(false);
    }, 3000);
  };

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (!user) return navigate('/');
    });
  }, [navigate]);

  const logout = () => signOut(auth);

  return (
    <div>
      <Modal centered isOpen={true}>
        <ModalBody>
          <FormText>
            <h5 className='px-3 text-center'>
              Fill in the given field and{' '}
              <strong style={{ color: '#575151' }}>hit generate button</strong>{' '}
              to generate a link for user.
            </h5>
          </FormText>
          <Formik
            initialValues={{
              u: '',
              a: '',
              up: ''
            }}
            validationSchema={schema}
            enableReinitialize
            onSubmit={(values) => {
              const data = {
                ...values,
                e: moment().unix() + 300 * 60,
                ap: state
              };
              addLinkData(JSON.stringify(data), 1);
            }}
          >
            {() => (
              <Form>
                <FormGroup>
                  <Label for='u'>User name</Label>
                  <Field
                    type='text'
                    name='u'
                    id='u'
                    placeholder='User Name...'
                    class='form-control'
                  />
                  <ErrorMessage
                    component='div'
                    name='u'
                    style={{ color: 'red' }}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for='a'>Amount</Label>
                  <Field
                    name='a'
                    id='a'
                    placeholder='*********'
                    type='number'
                    class='form-control'
                  />
                  <ErrorMessage
                    component='span'
                    name='a'
                    style={{ color: 'red' }}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for='up'>UPI ID</Label>
                  <Field
                    name='up'
                    id='up'
                    placeholder='*********'
                    type='text'
                    class='form-control'
                  />
                  <ErrorMessage
                    component='span'
                    name='up'
                    style={{ color: 'red' }}
                  />
                </FormGroup>
                <Label>New App Link Latest</Label>
                <div class='input-group'>
                  <input
                    type='text'
                    className='form-control text-ellipsis'
                    value={urlLatest}
                    disabled
                  />
                  <div className='input-icon'>
                    {copiedUrlLatest ? (
                      <GiConfirmed
                        size={'1.5rem'}
                        style={{ cursor: 'pointer', color: '#09f109' }}
                      />
                    ) : (
                      <MdOutlineFileCopy
                        onClick={handleCopyLatest}
                        size={'1.5rem'}
                        color={'blue'}
                        style={{ cursor: 'pointer' }}
                      />
                    )}
                  </div>
                </div>
                <Label>New App Link 1</Label>
                <div class='input-group'>
                  <input
                    type='text'
                    className='form-control text-ellipsis'
                    value={url1}
                    disabled
                  />
                  <div className='input-icon'>
                    {copiedUrl1 ? (
                      <GiConfirmed
                        size={'1.5rem'}
                        style={{ cursor: 'pointer', color: '#09f109' }}
                      />
                    ) : (
                      <MdOutlineFileCopy
                        onClick={handleCopyUrl1}
                        size={'1.5rem'}
                        color={'blue'}
                        style={{ cursor: 'pointer' }}
                      />
                    )}
                  </div>
                </div>
                <Label>New App Link</Label>
                <div class='input-group'>
                  <input
                    type='text'
                    className='form-control text-ellipsis'
                    value={urlOld}
                    disabled
                  />
                  <div className='input-icon'>
                    {copiedOld ? (
                      <GiConfirmed
                        size={'1.5rem'}
                        style={{ cursor: 'pointer', color: '#09f109' }}
                      />
                    ) : (
                      <MdOutlineFileCopy
                        onClick={handleCopyOld}
                        size={'1.5rem'}
                        color={'blue'}
                        style={{ cursor: 'pointer' }}
                      />
                    )}
                  </div>
                </div>
                <Label>Link</Label>
                <div class='input-group'>
                  <input
                    type='text'
                    className='form-control text-ellipsis'
                    value={url}
                    disabled
                  />
                  <div className='input-icon'>
                    {copied ? (
                      <GiConfirmed
                        size={'1.5rem'}
                        style={{ cursor: 'pointer', color: '#09f109' }}
                      />
                    ) : (
                      <MdOutlineFileCopy
                        onClick={handleCopy}
                        size={'1.5rem'}
                        color={'blue'}
                        style={{ cursor: 'pointer' }}
                      />
                    )}
                  </div>
                </div>

                <Label>Link 2</Label>
                <div class='input-group'>
                  <input
                    type='text'
                    className='form-control text-ellipsis'
                    value={url2}
                    disabled
                  />
                  <div className='input-icon'>
                    {copied2 ? (
                      <GiConfirmed
                        size={'1.5rem'}
                        style={{ cursor: 'pointer', color: '#09f109' }}
                      />
                    ) : (
                      <MdOutlineFileCopy
                        onClick={handleCopyUrl2}
                        size={'1.5rem'}
                        color={'blue'}
                        style={{ cursor: 'pointer' }}
                      />
                    )}
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center py-2 flex-column gap-3'>
                  <Button type='submit' color='primary' className='px-5'>
                    Generate Link
                  </Button>

                  <Button color='primary' className='px-5' onClick={logout}>
                    Logout
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default UTIForm;
